import { domToReact } from 'html-react-parser';
import { ConsultationForm } from '../components/ConsultationForm';
import { LeahChat } from '../components/LeahChat';
import { renderNavigation, renderFooterLinks, renderInternalLink } from './siteNavigation';
import headings from '../content/pageHeadings.json';

function renderHeading({node, props, sourcePath, options}) {
  const path = sourcePath === '/home' ? '/' : sourcePath;
  return <><h1 {...props}>{headings[path]}</h1><p className="original-editorial-copy" data-testid={`${props['data-testid']}-supporting-copy`}>{domToReact(node.children, options)}</p></>;
}

function renderDetails({ node, props, options }) {
  const reflectExpanded = event => event.currentTarget.querySelector('summary')?.setAttribute('aria-expanded', String(event.currentTarget.open));
  return <details {...props} onToggle={reflectExpanded}>{domToReact(node.children, options)}</details>;
}

function renderSummary({ node, props, options }) {
  return <summary {...props} role="button" aria-label="Menu" aria-controls="site-mobile-menu" aria-expanded="false" data-testid="mobile-menu-toggle">{domToReact(node.children, options)}</summary>;
}

function renderDropdown({ node, props, options }) {
  const reopen = event => event.currentTarget.removeAttribute('data-menu-dismissed');
  return <div {...props} onMouseEnter={reopen} onFocus={reopen}>{domToReact(node.children, options)}</div>;
}

function isFooterGroup({ node }) {
  return node.name === 'div' && node.parent?.attribs?.['aria-label'] === 'Footer'
    && node.children.some(child => child.name === 'a' && child.attribs?.href === '/our-team');
}

function isInternalLink({ node, standalone }) {
  if (node.name !== 'a') return false;
  const href = node.attribs.href || '';
  return /^\/(?!\/)/.test(href) || (standalone && href.startsWith('#'));
}

// First match wins, preserving the original source-markup replacement order.
export const siteRenderers = [
  { matches: ({node, sourcePath}) => node.name === 'h1' && Boolean(headings[sourcePath === '/home' ? '/' : sourcePath]), render: renderHeading },
  { matches: ({ node }) => node.name === 'details' && node.children.some(child => child.name === 'summary'), render: renderDetails },
  { matches: ({ node }) => node.name === 'summary' && node.parent?.name === 'details', render: renderSummary },
  { matches: ({ node }) => Boolean(node.attribs['data-consultation-form']), render: ({ node, props, sourcePath }) => <ConsultationForm key={props['data-testid']} node={node} sourcePath={sourcePath} /> },
  { matches: ({ node }) => Boolean(node.attribs['data-chat-widget']), render: ({ node }) => <LeahChat node={node} /> },
  { matches: ({ node }) => Boolean(node.attribs['data-dropdown-parent']), render: renderDropdown },
  { matches: ({ node }) => node.name === 'nav' && ['Primary', 'Menu'].includes(node.attribs['aria-label']), render: renderNavigation },
  { matches: isFooterGroup, render: renderFooterLinks },
  { matches: ({ node, standalone }) => standalone && node.name === 'p' && node.attribs['data-testid']?.includes('mailbox-remain-launch-g'), render: () => <></> },
  { matches: isInternalLink, render: renderInternalLink },
];